import * as React from "react";
const SvgAlert = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", width: "16px", height: "16px", viewBox: "0 0 16 16", style: {
  enableBackground: "new 0 0 16 16"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("rect", { x: 7, y: 11, style: {
  fill: "#010101"
}, width: 2, height: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 7, y: 3, style: {
  fill: "#010101"
}, width: 2, height: 7.001 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#010101"
}, d: "M8,0C3.581,0,0,3.581,0,8c0,4.418,3.581,8,8,8c4.418,0,8-3.582,8-8C16,3.581,12.418,0,8,0z M8,15 c-3.866,0-7-3.135-7-7c0-3.866,3.134-7,7-7c3.865,0,7,3.134,7,7C15,11.865,11.865,15,8,15z" })));
export default SvgAlert;
